import { useTokenStore } from 'Shared/hooks/useTokenStore';
import { serviceApi, withServiceRequestDefaults } from 'Shared/network';
import { QUERY_KEY } from '@constants';
import type { GetUserInformationResponse } from 'viewup-api/v2';
import type { QueryParam } from 'viewup-lib/common';
import { useSDQuery } from 'viewup-lib/react';

export const useGetInformation = (params?: QueryParam<GetUserInformationResponse>) => {
  const { accessToken } = useTokenStore();

  return useSDQuery({
    ...params?.options,
    enabled: params?.options?.enabled ?? !!accessToken,
    queryKey: [QUERY_KEY.INFORMATION],
    queryFn: async () => {
      const response = await serviceApi.user.getUserInformation(withServiceRequestDefaults());
      return response.data;
    },
  });
};
